import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import Header from './Header';

export default function Terms() {
  const { userId } = useParams(); 
  const contactEmail = "info@redish.com";

  return (
    <Container maxWidth="sm" sx={{ py: 2 }}>
      
      <Header userId={userId} />
      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
          Re:Dish Co. Terms of Service
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
          Last updated: September 30, 2025
        </Typography>
      </Box>
      <Box sx={{ mt: 3 }}>
        
        <Typography variant="body2" sx={{mt: 1}}>
        These are the terms of service (these “Terms”) for the point of sale reusable dishware program being conducted by Re:Dish Co. (“Re:Dish”). The reusable dishware that you are being asked to scan in connection with this program are provided by Re:Dish and your use of that dishware and our processing of your contact and payment information in connection with this program are subject to these Terms.
        </Typography>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
            Payment Method and Return Fees
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
        You hereby authorize Re:Dish to collect your contact information and payment information. 
        Payment information will be obtained via a third party service, Stripe. This information will be held and processed in accordance with Re:Dish’s privacy policy for this program, which you can find here: https://dishlink.redish.com/privacy. </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
        If the dishware items you scan at checkout are not returned, you agree to be charged $6 per item via your provided payment mechanism for each scanned item not returned within seven days (“Lost Item Fee”). You hereby authorize Re:Dish to charge your payment method.
        </Typography>
        
      </Box>
      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
            Consent to Receive SMS
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}  >
            SMS messages are an integral part of this service, and you consent to receive SMS messages to notify you of payment processing events, to remind you to return containers, for login verification, and for any other customer service responses concerning this program.
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >
            Message and data rates may apply depending on your mobile carrier.
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >
          By opting into SMS messages from Re:Dish Co, you agree to receive text messages related to:
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >
          <b>Login verification</b>
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >
        <b>Dishware return reminders</b>
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >
          <b>Customer support notifications</b>
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >
          Message frequency may vary. <b>Message and data rates may apply from your mobile carrier.</b>
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >
          You may opt out at any time by replying STOP to any message. You may also reply HELP for support or additional information.
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >  
          Your consent to receive SMS messages is not a condition of purchase.
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >  
         We do not share, sell, or transfer your mobile opt-in data or phone number to third parties for marketing purposes. For more details on how we collect and use your data, please view our <a href="https://dishlink.redish.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >  
        If you have questions about this policy or need assistance, contact us at {contactEmail}.
        </Typography>
      </Box>
      
      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
            Limitation of Liability and Indemnification
        </Typography>
        <Typography variant="body2" sx={{mt: 1}} >
            RE:DISH SHALL NOT BE LIABLE TO YOU FOR ANY INDIRECT OR CONSEQUENTIAL DAMAGES ARISING DIRECTLY OR INDIRECTLY FROM YOUR USE OF DISHWARE PROVIDED BY RE:DISH OR RE:DISH'S COLLECTION AND CHARGING OF YOUR PAYMENT INFORMATION. YOU AGREE THAT RE:DISH SHALL NOT BE LIABLE TO YOU UNDER ANY THEORY OF LIABILITY, WHETHER CONTRACT, TORT, STRICT LIABILITY OR ANY OTHER THEORY FOR AN AMOUNT GREATER THAN THE LOST ITEM FEE OR ANY AMOUNT IMPROPERLY CHARGED TO YOUR PAYMENT METHOD.
        </Typography>
         <Typography variant="body2" sx={{mt: 1}} >
            YOU AGREE TO FOLLOW THE RULES AND RESTRICTIONS FOR THE USE OF THE DISHWARE, A COPY OF WHICH YOU CAN FIND HERE: <a href="https://www.redish.com/userfaqs" target="_blank" rel="noopener noreferrer">https://www.redish.com/userfaqs</a> AND TO DEFEND, INDEMNIFY AND HOLD RE:DISH HARMLESS FOR ANY CLAIMS OR DAMAGE ARISING FROM FAILURE TO FOLLOW THESE RULES AND RESTRICTIONS.
         </Typography>
          
      </Box>
      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
            Governing Law & Venue
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
        These Terms are governed by the laws of the State of New York, without regard to its conflict of law principles. Any legal actions or proceedings shall be brought exclusively in the courts located in New York County, New York.  
        </Typography>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
            Contact Information
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
        You can contact Re:Dish with any comments or complaints at:
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
        {contactEmail}
        </Typography>
      </Box>

      <Box sx={{ mt: 3 }}>
        <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
        Changes to These Terms
        </Typography>
        <Typography variant="body2" sx={{mt: 1}}>
        These terms were last updated on the date indicated above.  Re:Dish may change these terms at any time, and your continued participation in this program constitutes consent to those changes.</Typography>
      </Box>
    </Container>
  );
}
